import { jsxs as r, jsx as C } from "react/jsx-runtime";
function l(e) {
  return /* @__PURE__ */ r("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M5.70699 4.293C5.31639 3.9024 4.68359 3.9024 4.29289 4.293C3.90219 4.6836 3.90229 5.3164 4.29289 5.7071L5.61059 7.0248C2.99679 8.9766 2.06529 11.6413 2.05159 11.6836C1.99979 11.8384 1.98619 12.0034 2.01349 12.1646C2.02519 12.233 3.25369 19 11.9998 19C13.8366 19 15.3529 18.6097 16.6111 18.0253L18.2927 19.707C18.488 19.9023 18.7439 20 18.9997 20C19.2555 20 19.5114 19.9023 19.7067 19.707C20.0973 19.3164 20.0973 18.6836 19.7067 18.2929L5.70699 4.293ZM10.0864 11.5005L12.4992 13.9133C12.3382 13.9558 12.1744 13.9927 11.9999 13.9927C10.9013 13.9927 10.0067 13.0987 10.0067 12C10.0067 11.8254 10.0438 11.6615 10.0864 11.5005ZM12 17C5.78809 17 4.32129 13.1025 4.04199 12.0752C4.31079 11.4347 5.18869 9.7175 7.04269 8.4567L8.93409 10.3482C8.66479 10.8395 8.50689 11.3999 8.50689 12C8.50689 13.9258 10.0743 15.4927 12.0001 15.4927C12.6001 15.4927 13.1605 15.335 13.6517 15.0658L15.0752 16.4892C14.1937 16.7968 13.1866 17 12 17Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M21.9482 11.6836C21.9267 11.6167 19.6328 5 12 5C11.014 5 10.1207 5.1138 9.3063 5.3063L11.044 7.044C11.3508 7.016 11.6685 7 12.0001 7C17.3507 7 19.4239 10.8457 19.9259 11.9995C19.7169 12.4801 19.2316 13.4224 18.3607 14.3606L19.756 15.7559C21.3371 14.0696 21.9374 12.3504 21.9484 12.3164C22.0177 12.1108 22.0175 11.8892 21.9482 11.6836Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  l as default
};
